import React from 'react';
import PropTypes from 'prop-types';

import { container, title, link } from './recipe-simple-header.module.scss';
import useRecipeAbsolutePath from '../../../hooks/use-recipe-absolute-path';

const RecipeSimpleHeader = ({ recipe, className = '' }) => {
    const recipePath = useRecipeAbsolutePath(recipe);

    return (
        <div className={`${container} ${className}`}>
            <a href={recipePath} rel="noopener noreferrer" target="_blank" className={link}>
                <h2 className={title}>{recipe.name}</h2>
            </a>
        </div>
    );
};

RecipeSimpleHeader.propTypes = {
    recipe: PropTypes.object.isRequired,
    className: PropTypes.string,
};

RecipeSimpleHeader.defaultProps = {
    className: '',
};

export default RecipeSimpleHeader;
